<template>
    <div>
        <report-header
            :title="title"
            :isShowDateRange="true"
            :formatDateRangeTitle="dateRange"
        />
        <b-card>
            <div
                id="report-chart"
                class="my-5"
                style="height: 250px; overflow-y: inherit;"
            ></div>
            <div v-if="!loaded">
                <img src="assets/ajax-loader.gif" style="padding: 10px;" />
            </div>
            <div v-if="loaded" id="report-body" class="w-100">
                <div v-if="formattedResult.length > 0">
                    <b-table-simple bordered>
                        <b-thead head-variant="dark">
                            <tr>
                                <th>Month</th>
                                <th>Clients</th>
                            </tr>
                        </b-thead>

                        <tbody>
                            <tr
                                :key="item.month"
                                v-for="item in formattedResult"
                            >
                                <td>{{ item.month }}</td>
                                <td>{{ item.clients }}</td>
                            </tr>
                        </tbody>
                    </b-table-simple>
                </div>
                <div v-else>
                    <i>No records available</i>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import "@/jquery/jquery.flot";
import Report from "@/mixins/report";
export default {
    components: {
        ReportHeader: () => import("@/components/report/report-header")
    },
    mixins: [Report],
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: this.getStartDate("month"),
                    end: this.getEndDate("day"),
                    datePickerOptions: {
                        format: "MMM YYYY"
                    }
                };
            }
        }
    },
    data() {
        return {
            locale: "en-US",
            timezone: "America/Los_Angeles",
            loaded: false,
            meta: "",
            code: "",
            xaxis: [],
            formattedData: [],
            result: [],
            formattedResult: [],
            title: "Active Clients Summary",
            dateRange: ""
        };
    },
    mounted() {
        let self = this;
        self.data.isShowDateRange = true;

        self.data.start = self.getStartDate("month");
        self.data.end = self.getEndDate("day");
        self.data.from = self.converToUnix(self.data.start);
        self.data.to = self.converToUnix(self.data.end);

        self.data.datePickerOptions.format = "MMM YYYY";

        self.init();
        self.$root.$on("report-filter-date-range:refresh", this.init);
    },
    beforeDestroy: function () {
        this.$root.$off("report-filter-date-range:refresh", this.init);
    },
    methods: {
        init(params) {
            let self = this;
            if (params) {
                self.data.from = params.from;
                self.data.to = params.to;
                self.data.start = params.start;
                self.data.end = params.end;
            }
            self.loaded = false;
            self.dateRange = self.getDateRange(self.data.from, self.data.to, "LLL yyyy");

            return this.$http
                .get(
                    process.env.BARRACUDA +
                        "/report/reports/" +
                        self.$route.params.id,
                    {
                        params: {
                            from: params
                                ? params.from
                                    ? params.from
                                    : self.data.start.unix()
                                : self.data.start.unix(),
                            to: params
                                ? params.to
                                    ? params.to
                                    : self.data.end.unix()
                                : self.data.end.unix()
                        }
                    }
                )
                .then(function (response) {
                    self.meta = response.data.response.resource.meta;
                    self.timezone = self.meta.timezone;
                    self.locale = self.meta.locale.replace("_", "-");
                    self.code = response.status;
                    self.dynamicPageTitle(self.title);

                    if (self.code === 200) {
                        self.loaded = true;
                        self.result = response.data.response.resource.results;
                        self.formatResult(
                            response.data.response.resource.results
                        );
                        self.dateRange = self.getDateRange(
                            response.data.response.resource.meta.from,
                            response.data.response.resource.meta.to,
                            "LLL yyyy"
                        );

                        self.$nextTick().then(() => {
                            self.renderChart(self.result);
                        });
                    }
                });
        },
        formatResult(result) {
            let self = this;
            let monthArray = self.renderDateRangeArray(
                "MMM YY",
                self.meta.timezone
            );
            let data = [];

            $.each(monthArray, function (i, o) {
                let month = moment(o[1], "MMM YY");
                let arr = {
                    clients: 0,
                    month: month.format("MMM YYYY")
                };

                $.each(result, function (k, v) {
                    let month1 = moment(v["month"], "MMM YYYY").tz(
                        self.meta.timezone
                    );
                    if (month.isSame(month1)) {
                        arr["clients"] = v["clients"];
                        return false;
                    }
                });

                data.push(arr);
            });

            self.formattedResult = data;
        },
        renderChart(result) {
            let self = this;
            self.xaxis = self.renderDateRangeArray(
                "MMM YY",
                self.meta.timezone
            );
            self.formattedData = self.renderResult(
                self.xaxis,
                result,
                "MMM YY",
                self.meta.timezone
            );

            let data = [
                {
                    label: "",
                    data: self.formattedData,
                    color: "#84BBF9"
                }
            ];

            let options = {
                series: {
                    bars: {
                        show: true,
                        fill: true,
                        barWidth: 0.9,
                        align: "center"
                    },
                    points: {
                        show: false
                    }
                },
                grid: {
                    borderWidth: 0,
                    hoverable: false
                },
                xaxis: {
                    ticks: self.xaxis,
                    tickLength: 0
                },
                tooltip: true,
                tooltipOpts: {
                    content: "%y.4",
                    shifts: {
                        x: 20,
                        y: 0
                    },
                    defaultTheme: false
                }
            };

            $.plot($("#report-chart"), data, options);
        },
        renderDateRangeArray(format = "YYYY-MMM") {
            let self = this;
            let data = [];
            let from = self.data.start.clone();
            let to = self.data.end.clone();
            let index = 1;

            while (from.diff(to) < 0) {
                let arr = [];

                arr.push(index);
                arr.push(from.clone().format(format));

                data.push(arr);
                index++;
                from.add(1, "months");
            }

            return data;
        },
        renderResult(xaxis = [], result, format = "YYYY-MMM", timezone) {
            let data = [];
            let index = 1;

            $.each(xaxis, function (i, o) {
                let month = moment(o[1], format).tz(timezone);
                let arr = [];

                arr.push(index);
                arr.push(0);

                $.each(result, function (k, v) {
                    let month1 = moment(v["month"], "MMM YYYY").tz(timezone);
                    if (month.isSame(month1)) {
                        arr[1] = v["clients"];
                        return false;
                    }
                });

                data.push(arr);
                index++;
            });

            return data;
        }
    }
};
</script>
